"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropdownType = exports.contactType = void 0;

var _propTypes = require("prop-types");

var dropdownType = (0, _propTypes.shape)({
  id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]).isRequired,
  text: _propTypes.string.isRequired
});
exports.dropdownType = dropdownType;
var contactType = (0, _propTypes.shape)({
  name: _propTypes.string,
  account: _propTypes.string,
  image: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element])
});
exports.contactType = contactType;